"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromDto = exports.toDto = void 0;
const tslib_1 = require("tslib");
const Point_1 = require("json-joy/lib/json-crdt-extensions/peritext/rga/Point");
const Range_1 = require("json-joy/lib/json-crdt-extensions/peritext/rga/Range");
const constants_1 = require("json-joy/lib/json-crdt-extensions/peritext/rga/constants");
const id = tslib_1.__importStar(require("./id"));
/**
 * Converts Peritext range-based selections to serializable DTOs for presence
 * syncing.
 *
 * @param txt The Peritext API instance.
 * @param selections Collection of Peritext range selections.
 * @returns RGA selection entry with all selections encoded as CRDT ID-based cursors.
 */
const toDto = (txt, selections) => {
    const clock = txt.model.clock;
    const sid = clock.sid;
    const strNode = txt.str;
    const nodeId = id.toDto(sid, strNode.id);
    const cursors = [];
    for (const [range, startIsAnchor] of selections) {
        const start = range.start;
        const end = range.end;
        const anchorPt = startIsAnchor ? start : end;
        const focusPt = startIsAnchor ? end : start;
        const anchorPoint = [id.toDto(sid, anchorPt.id), anchorPt.anchor];
        if (range.isCollapsed()) {
            cursors.push([anchorPoint]);
        }
        else {
            const focusPoint = [id.toDto(sid, focusPt.id), focusPt.anchor];
            cursors.push([anchorPoint, focusPoint]);
        }
    }
    const selection = ['', '', sid, clock.time, {}, 4 /* JsonCrdtDataType.str */, nodeId, cursors];
    return selection;
};
exports.toDto = toDto;
/**
 * Converts a CRDT ID-based RGA selection back to Peritext `StablePeritextSelection`
 * entries. This is the inverse of {@link toDto}.
 *
 * @param txt The Peritext instance for the target "str" node.
 * @param selection The RGA selection DTO to convert.
 * @returns Collection of `StablePeritextSelection` tuples, or an empty array if
 *     the selection type is not "str".
 */
const fromDto = (txt, selection) => {
    const [_documentId, _uiLocationId, sid, _time, _meta, type, _nodeIdDto, cursors] = selection;
    const result = [];
    if (type !== 4 /* JsonCrdtDataType.str */)
        return result;
    const str = txt.str;
    for (const cursor of cursors) {
        const [anchorPointDto, focusPointDto] = cursor;
        const anchorId = id.fromDto(sid, anchorPointDto[0]);
        const anchorAnchor = anchorPointDto[1] ?? constants_1.Anchor.After;
        if (focusPointDto) {
            const focusId = id.fromDto(sid, focusPointDto[0]);
            const focusAnchor = focusPointDto[1] ?? constants_1.Anchor.After;
            const anchorPt = new Point_1.Point(str, anchorId, anchorAnchor);
            const focusPt = new Point_1.Point(str, focusId, focusAnchor);
            const range = txt.rangeFromPoints(anchorPt, focusPt);
            const startIsAnchor = range.start === anchorPt;
            result.push([range, startIsAnchor]);
        }
        else {
            const pt = new Point_1.Point(str, anchorId, anchorAnchor);
            const range = new Range_1.Range(str, pt, pt.clone());
            result.push([range, true]);
        }
    }
    return result;
};
exports.fromDto = fromDto;
